import React from 'react';

import StubWrapper from './StubWrapper';
import CoverStub from './CoverStub';
import LineStub from './LineStub';
import UserAvatarStub from './UserAvatarStub';

class PublicationRowStub extends React.PureComponent {
  render() {
    return (
      <StubWrapper>
        <CoverStub />

        <div style={{ width: '100%' }}>
          <LineStub style={{ width: '391px', marginBottom: '16px' }} />

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <UserAvatarStub />

            <LineStub style={{ marginRight: '181px' }} />

            <LineStub style={{ marginLeft: 'auto', marginRight: '120px' }} />

            <LineStub />
          </div>
        </div>
      </StubWrapper>
    );
  }
}

export default PublicationRowStub;
